import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styled, { keyframes } from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var barExpander = function barExpander(height) {
  return keyframes(["0%,80%,100%{height:", "px;}40%{height:", "px;}"], height / 1.8, height);
};
var Container = styled.div.withConfig({
  displayName: "GraphLoaderAnimation__Container",
  componentId: "sc-eprmqq-0"
})(["display:flex;justify-content:center;"]);
var Bar = styled.div.withConfig({
  displayName: "GraphLoaderAnimation__Bar",
  componentId: "sc-eprmqq-1"
})(["animation:", " 1s infinite cubic-bezier(0.52,0.04,0.85,1.06);", ""], function (_ref) {
  var height = _ref.height;
  return barExpander(height);
}, function (_ref2) {
  var theme = _ref2.theme,
    height = _ref2.height,
    delay = _ref2.delay;
  return "\n    margin: auto 2px;\n    width: 12px;\n    height: ".concat(height / 1.8, "px;\n    position: relative;\n\n    background: ").concat(theme.colors.P3, ";\n    animation-delay: ").concat(delay, "s;\n    transform: translateZ(0);\n  ");
});
export default function GraphLoaderAnimation(props) {
  var style = props.style,
    height = props.height,
    width = props.width;
  return /*#__PURE__*/_jsxs(Container, {
    style: _objectSpread({
      height: "".concat(height, "px"),
      width: "".concat(width, "px")
    }, style),
    children: [/*#__PURE__*/_jsx(Bar, {
      height: height,
      delay: 0
    }), /*#__PURE__*/_jsx(Bar, {
      height: height,
      delay: 0.16
    }), /*#__PURE__*/_jsx(Bar, {
      height: height,
      delay: 0.32
    })]
  });
}